const Blockly = require('blockly');
const { merge } = require('lodash');
const { actionUtils } = require('@sstdev/lib_metadata-config');
const mdcConfig = require('@sstdev/lib_metadata-config');
const dataAccessMethods = require('../../../../dataAccessMethods');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const { config, moduleRegistration } = mdcConfig;

const TOOLTIP = 'Display a dynamically generated import dialog to import data for the selected namespace/relation';
/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    const workspace = blocklyBlock.workspace;
    const blockId = blocklyBlock.id;

    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged vertically.
    //Meaning each (dummy)input starts a new line
    blocklyBlock.setInputsInline(false);

    line1OfInputs
        .appendField('  Namespace:')
        .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace')
        .appendField('  Relation:')
        .appendField(new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)), 'relation')
        .appendField('Display Import Title')
        .appendField(new Blockly.FieldCheckbox('TRUE'), 'displayImportTitle');

    // Load possible actions and default action
    const actionsDropdown = new Blockly.FieldDropdown(config.actionElementActions);
    line1OfInputs.appendField('  For Action:').appendField(actionsDropdown, 'forAction');

    // Set button style
    let styleDropDown = new Blockly.FieldDropdown(config.buttonStyles);
    styleDropDown.setValue('IconAction');

    // Line 2 of inputs
    blocklyBlock
        .appendDummyInput()
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField('  Button Size (new):')
        .appendField(new Blockly.FieldDropdown(config.componentSize), 'size')
        .appendField('  Button Variant (new):')
        .appendField(new Blockly.FieldDropdown(config.buttonVariants), 'variant')
        .appendField('  Icon Name:')
        .appendField(new Blockly.FieldTextInput('cloud_upload'), 'iconName');

    blocklyBlock
        .appendStatementInput('children')
        .setCheck(['formElement'])
        .appendField('FormElements:', 'childrenField');
}

/**
 * @param {{[key: string]: any}} code
 * @param {import('blockly').Block} blocklyBlock
 * @return {{[key: string]: any}}
 */
function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['namespace', 'relation', 'forAction', 'size', 'variant', 'iconName']);

    code.forAction = 'import';
    code.cancelAction = 'close';
    code.displayImportTitle = 'TRUE' === blocklyBlock.getFieldValue('displayImportTitle');

    return code;
}

/**
 * Builds relation metadata for the ImportForm action.
 * This is an import-specific form that should NOT write to the canonical relation slot.
 * Import schemas have their own validation rules and should not override canonical create/update constraints.
 * This block only propagates child contributions without creating a canonical relation entry.
 */
function asDataDictionary(hNode, context, parentAccessRestrictions) {
    const { children } = hNode;

    const accessRestrictions = actionUtils.getNodeAccessRestrictions(hNode, context, parentAccessRestrictions);
    if (accessRestrictions.hidden) return [{}, {}];

    let [_subDataDictionary = {}, _partialTypeDefinition = {}] = children?.reduce(
        ([sdd, ptd], child) => {
            const [_subDataDictionary = {}, _partialTypeDefinition = {}] = context.extractFromChild(
                child,
                context,
                accessRestrictions
            );
            return [
                merge(sdd, _subDataDictionary),
                moduleRegistration.mergePartialTypeDefinitions(ptd, _partialTypeDefinition, context)
            ];
        },
        [{}, {}]
    ) ?? [{}, {}];

    // View-only block: only pass through child subDataDictionary contributions.
    // Do NOT create or merge into the canonical [namespace][relation] slot.
    // Import forms have their own validation context separate from canonical create/update.
    return [_subDataDictionary, _partialTypeDefinition];
}

module.exports = { addBlockSpecificFields, asDataDictionary, convertCustomFieldsToCode };
